import { render, staticRenderFns } from "./LanguageLevel.vue?vue&type=template&id=71bdff0e&scoped=true&"
import script from "./LanguageLevel.vue?vue&type=script&lang=js&"
export * from "./LanguageLevel.vue?vue&type=script&lang=js&"
import style0 from "./LanguageLevel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LanguageLevel.vue?vue&type=style&index=1&id=71bdff0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdff0e",
  null
  
)

export default component.exports